export default __webpack_public_path__ + "static/dni-6611dd88f696700384f64689b3f984a2.png";